import instance from '@/utils/instance';

//VIP商品
export function getVipInfo() {
	return instance({
		url: `/webL_api/essential/api/vipInfo`,
		method: 'get'
	});
}

//创建VIP订单
export function postOrderVipBuy(data) {
	return instance({
		url: `/webL_api/consumer/order/vipBuy`,
		method: 'post',
        data
	});
}

//VIP订单列表
export function getOrderVipList(data) {
	return instance({
		url: `/webL_api/consumer/order/vipList`,
		method: 'post',
        data
	});
}